<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Buat Permohonan</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              Buat Permohonan
            </div>
          </div>
        </div>
				
        <div class="section-body">
          <!-- 
            Jika Role Operator desa, Kades, RS,
            ada pilih penduduk,
            ada header informasi penduduk yang dibantu
            -->
          <div v-if="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa' || namaRole === 'Rumah Sakit'">
            <div
              v-if="!penduduk"
              class="card card-primary"
            >
              <div class="card-header">
                <h4 class="d-inline">
                  Pilih Penduduk
                </h4>
              </div>
              <div class="card-body">
                <p>Pilih penduduk yang akan diinputkan permohonannya</p>
                <SearchPenduduk @pilihPenduduk="pilihPenduduk" />
                <div class="alert alert-secondary text-dark alert-has-icon">
                  <div class="alert-icon">
                    <i class="far fa-lightbulb" />
                  </div>
                  <div class="alert-body">
                    <div class="alert-title">
                      Informasi
                    </div>
                    Jika data penduduk tidak ditemukan di Jembrana, Anda dapat menambahkan data sementara untuk membuat permohonan penduduk yang bersangkutan.<br>
                    <button
                      class="btn btn-primary mt-3"
                      @click="$bvModal.show('modal-tambah-penduduk')"
                    >
                      Tambah Penduduk
                    </button>
                  </div>
                </div>

                <b-modal
                  id="modal-tambah-penduduk"
                  title="Tambah Penduduk"
                  size="lg"
                  hide-footer
                >
                  <div class="alert alert-primary alert-has-icon">
                    <div class="alert-icon">
                      <i class="far fa-lightbulb" />
                    </div>
                    <div class="alert-body">
                      <div class="alert-title">
                        Informasi
                      </div>
                      Setelah proses tambah penduduk penduduk berhasil, lanjutkan dengan proses input permohonan.
                    </div>
                  </div>
                  <form
                    action=""
                    method="POST"
                    @submit="submitAddPenduduk"
                  >
                    <div class="row">
                      <!-- jika penduduk non permanen -->
                      <div
                        class="col-sm-12"
                      >
                        <div
                          class="form-group row p-4 mx-1 mb-4"
                          style="background: #eee; border-radius: 5px"
                        >
                          <label
                            for="is_non_permanen1"
                            class="col-sm-6"
                          >Penduduk Non Permanen</label>
                          <div
                            class="col-sm-6"
                            style="display: flex"
                          >
                            <div
                              class="custom-control custom-radio mr-4"
                            >
                              <input
                                type="radio"
                                id="is_non_permanen1"
                                name="is_non_permanen"
                                class="custom-control-input"
                                value="0"
                                v-model="formPenduduk.is_non_permanen"
                              >
                              <label
                                class="custom-control-label"
                                for="is_non_permanen1"
                              >Tidak</label>
                            </div>
                            <div
                              class="custom-control custom-radio"
                            >
                              <input
                                type="radio"
                                id="is_non_permanen2"
                                name="is_non_permanen"
                                class="custom-control-input"
                                value="1"
                                v-model="formPenduduk.is_non_permanen"
                              >
                              <label
                                class="custom-control-label"
                                for="is_non_permanen2"
                              >Ya</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="nama_lengkap">Nama Lengkap</label>
                          <input
                            id="nama_lengkap"
                            type="text"
                            class="form-control" 
                            name="text"
                            required
                            v-model="formPenduduk.nama_lengkap"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="nik">NIK</label>
                          <input
                            id="nik"
                            type="number"
                            class="form-control" 
                            name="email"
                            required
                            v-model="formPenduduk.nik"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="no_kk">No KK</label>
                          <input
                            id="no_kk"
                            type="number"
                            class="form-control" 
                            name="email"
                            required
                            v-model="formPenduduk.no_kk"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="no_kk">Tempat Lahir</label>
                          <input
                            id="tempat_lahir"
                            type="text"
                            class="form-control" 
                            name="tempat_lahir"
                            required
                            v-model="formPenduduk.tempat_lahir"
                          >
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="tanggal_lahir">Tanggal Lahir</label>
                          <input
                            id="tanggal_lahir"
                            type="date"
                            class="form-control" 
                            name="tanggal_lahir"
                            required
                            v-model="formPenduduk.tanggal_lahir"
                          >
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="umur">Umur</label>
                          <div class="input-group">
                            <input
                              id="tanggal_lahir"
                              type="number"
                              class="form-control text-right" 
                              name="umur"
                              disabled
                              v-model="formPenduduk.umur"
                            >
                            <div class="input-group-append">
                              <div class="input-group-text">
                                Tahun
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="idKelaminL">Jenis Kelamin</label>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="idKelaminL"
                              name="id_kelamin"
                              class="custom-control-input"
                              value="1"
                              v-model="formPenduduk.id_kelamin"
                            >
                            <label
                              class="custom-control-label"
                              for="idKelaminL"
                            >Laki-laki</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="idKelaminP"
                              name="id_kelamin"
                              class="custom-control-input"
                              value="2"
                              v-model="formPenduduk.id_kelamin"
                            >
                            <label
                              class="custom-control-label"
                              for="idKelaminP"
                            >Perempuan</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="statusKawinKawin">Status Kawin</label>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="statusKawinKawin"
                              name="status_kawin"
                              class="custom-control-input"
                              value="Kawin"
                              v-model="formPenduduk.status_kawin"
                            >
                            <label
                              class="custom-control-label"
                              for="statusKawinKawin"
                            >Kawin</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="statusKawinBelumKawin"
                              name="status_kawin"
                              class="custom-control-input"
                              value="Belum Kawin"
                              v-model="formPenduduk.status_kawin"
                            >
                            <label
                              class="custom-control-label"
                              for="statusKawinBelumKawin"
                            >Belum Kawin</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="statusKawinCeraiHidup"
                              name="status_kawin"
                              class="custom-control-input"
                              value="Cerai Hidup"
                              v-model="formPenduduk.status_kawin"
                            >
                            <label
                              class="custom-control-label"
                              for="statusKawinCeraiHidup"
                            >Cerai Hidup</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="statusKawinCeraiMati"
                              name="status_kawin"
                              class="custom-control-input"
                              value="Cerai Mati"
                              v-model="formPenduduk.status_kawin"
                            >
                            <label
                              class="custom-control-label"
                              for="statusKawinCeraiMati"
                            >Cerai Mati</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="alamat">Alamat</label>
                          <input
                            id="alamat"
                            type="text"
                            class="form-control"
                            name="alamat"
                            required
                            v-model="formPenduduk.alamat"
                          >
                          <span class="valid-feedback d-block">
                            Jika penduduk datang, gunakan alamat tujuan
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="kecamatan">Kecamatan</label>
                          <v-select
                            v-model="id_kecamatan"
                            :options="optionKecamatan"
                            label="nama_kecamatan"
                            :loading="loadingKecamatan"
                            :clearable="false"
                          />
                          <span class="valid-feedback d-block">
                            Jika penduduk datang, gunakan kecamatan tujuan
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="desa">Desa</label>
                          <v-select
                            v-model="formPenduduk.id_desa"
                            :options="optionDesa"
                            label="nama_desa"
                            :loading="loadingDesa"
                            :clearable="false"
                          />
                          <span class="valid-feedback d-block">
                            Jika penduduk datang, gunakan desa tujuan
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="shdkKepalaKeluarga">Status Hubungan Dalam Keluarga</label>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkKepalaKeluarga"
                              name="shdk"
                              class="custom-control-input"
                              value="1"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkKepalaKeluarga"
                            >Kepala Keluarga</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkSuami"
                              name="shdk"
                              class="custom-control-input"
                              value="2"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkSuami"
                            >Suami</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkIstri"
                              name="shdk"
                              class="custom-control-input"
                              value="3"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkIstri"
                            >Istri</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkAnak"
                              name="shdk"
                              class="custom-control-input"
                              value="4"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkAnak"
                            >Anak</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkMenantu"
                              name="shdk"
                              class="custom-control-input"
                              value="5"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkMenantu"
                            >Menantu</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkCucu"
                              name="shdk"
                              class="custom-control-input"
                              value="6"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkCucu"
                            >Cucu</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkOrangTua"
                              name="shdk"
                              class="custom-control-input"
                              value="7"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkOrangTua"
                            >Orang Tua</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkMertua"
                              name="shdk"
                              class="custom-control-input"
                              value="8"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkMertua"
                            >Mertua</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="shdkFamiliLain"
                              name="shdk"
                              class="custom-control-input"
                              value="9"
                              v-model="formPenduduk.id_shdk"
                            >
                            <label
                              class="custom-control-label"
                              for="shdkFamiliLain"
                            >Famili Lain</label>
                          </div>
                          <input
                            type="hidden"
                            v-model="formPenduduk.shdk"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="agamaHindu">Agama</label>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaHindu"
                              name="agama"
                              class="custom-control-input"
                              value="1"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaHindu"
                            >Hindu</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaKatholik"
                              name="agama"
                              class="custom-control-input"
                              value="2"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaKatholik"
                            >Katholik</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaKristen"
                              name="agama"
                              class="custom-control-input"
                              value="3"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaKristen"
                            >Kristen</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaIslam"
                              name="agama"
                              class="custom-control-input"
                              value="4"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaIslam"
                            >Islam</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaBudha"
                              name="agama"
                              class="custom-control-input"
                              value="5"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaBudha"
                            >Budha</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaAliran"
                              name="agama"
                              class="custom-control-input"
                              value="6"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaAliran"
                            >Aliran Kepercayaan</label>
                          </div>
                          <div class="custom-control custom-radio">
                            <input
                              type="radio"
                              id="agamaHindu"
                              name="agamaKongHuCu"
                              class="custom-control-input"
                              value="7"
                              v-model="formPenduduk.id_agama"
                            >
                            <label
                              class="custom-control-label"
                              for="agamaKongHuCu"
                            >Kong HuChu</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="pend_terakhir">Pendidikan Terakhir</label>
                          <input
                            id="pend_terakhir"
                            type="text"
                            class="form-control"
                            name="pend_terakhir"
                            required
                            v-model="formPenduduk.pend_terakhir"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="pekerjaan">Pekerjaan</label>
                          <input
                            id="pekerjaan"
                            type="text"
                            class="form-control"
                            name="pekerjaan"
                            required
                            v-model="formPenduduk.pekerjaan"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="nama_lengkap_ayah">Nama Ayah</label>
                          <input
                            id="nama_lengkap_ayah"
                            type="text"
                            class="form-control"
                            name="nama_lengkap_ayah"
                            required
                            v-model="formPenduduk.nama_lengkap_ayah"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="nama_lengkap_ibu">Nama Ibu</label>
                          <input
                            id="nama_lengkap_ibu"
                            type="text"
                            class="form-control"
                            name="nama_lengkap_ibu"
                            required
                            v-model="formPenduduk.nama_lengkap_ibu"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="text-right">
                      <b-button
                        id="btnAddPenduduk"
                        class="mx-1"
                        type="submit"
                        variant="primary"
                      >
                        Tambah Penduduk
                      </b-button>
                      <b-button
                        type="button"
                        class="mx-1"
                        @click="$bvModal.hide('modal-tambah-penduduk')"
                      >
                        Batal
                      </b-button>
                    </div>
                  </form>
                </b-modal>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-light alert-has-icon">
                <div class="alert-icon">
                  <i class="far fa-lightbulb" />
                </div>
                <div class="alert-body">
                  <div class="alert-title">
                    Perhatian
                  </div>
                  Anda masuk ke dalam tahap <strong>Buat Permohonan</strong> untuk <strong>Penduduk</strong>.
                  Pastikan permohonan yang diinputkan sesuai dengan penduduk yang dipilih.
                  <b-button
                    v-b-toggle.collapse-penduduk
                    variant="primary"
                    size="sm"
                  >
                    <i class="fa fa-eye mr-2" />Lihat Penduduk
                  </b-button>
                  <b-collapse
                    id="collapse-penduduk"
                    class="mt-2"
                  >
                    <table class="table table-sm">
                      <tr>
                        <td>Nama Penduduk</td>
                        <td>:</td>
                        <td>{{ penduduk.nama_lengkap }}</td>
                      </tr>
                      <tr>
                        <td>NIK</td>
                        <td>:</td>
                        <td>{{ penduduk.nik }}</td>
                      </tr>
                      <tr>
                        <td>Desa</td>
                        <td>:</td>
                        <td>{{ penduduk.desa.nama_desa }}, {{ penduduk.desa.nama_kecamatan }}</td>
                      </tr>
                      <tr>
                        <td>Tempat Tanggal Lahir</td>
                        <td>:</td>
                        <td>
                          {{ penduduk.tempat_lahir }},
                          {{
                            new Date(penduduk.tanggal_lahir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" />
                        <td>
                          <button
                            class="btn btn-danger btn-sm"
                            @click="ubahPenduduk"
                          >
                            <i class="fa fa-times mr-2" />Ubah Penduduk
                          </button>
                        </td>
                      </tr>
                    </table>
                  </b-collapse>
                </div>
              </div>
              <LangkahPermohonan />
            </div>
          </div>

          <div v-if="namaRole === 'Penduduk'">
            <LangkahPermohonan />
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<script>
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'
import SearchPenduduk from './../../components/global/SearchPenduduk.vue'
import LangkahPermohonan from './../../components/langkahpermohonan/LangkahPermohonan.vue'

export default {
  name: 'BuatPermohonan',
  components: {
    LayoutAdmin, LangkahPermohonan, SearchPenduduk
  },
  data() {
    return {
      // penduduk: null // data penduduk yang dipilih untuk diinsert permohonannya
      // dipake di input permohonan oleh op des/ kades
      formPenduduk: {
        nama_lengkap: '',
        nik: '',
        no_kk: '',
        id_kelamin: '',
        tempat_lahir: '',
        tanggal_lahir: '',
        umur: '',
        status_kawin: '',
        shdk: '',
        id_shdk: '',
        pend_terakhir: '',
        pekerjaan: '',
        id_agama: '',
        nama_lengkap_ayah: '',
        nama_lengkap_ibu: '',
        alamat: '',
        id_desa: '',
        is_non_permanen: '0'
      },
      id_kecamatan: '',
      optionKecamatan: [{
        id_kecamatan: 0,
        nama_kecamatan: ''
      }],
      optionDesa: [{
        id_desa: 0,
        nama_desa: ''
      }],
      loadingKecamatan: false,
      loadingDesa: false,
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    penduduk() {
      return this.$store.getters.getPendudukBantu
    }
  },
  methods: {
    pilihPenduduk(data) {
      /**
       * Jika operator desa dan kepala desa,
       * perlu di cek apakah penduduk tsb merupakan penduduk desanya.
       * 
       * Jika Role Rumah Sakit [1/12/22]
       * Tidak Perlu Ngecek
       */
      if (
        (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') &&
        data.id_desa != this.$store.getters.getUser.id_desa
      ) {// kalau operator ambil di rbac_user id_desanya
        swal({
          title: "Kesalahan",
          text: `${data.nama_lengkap} merupakan warga Desa ${data.desa.nama_desa}. Sedangkan anda merupakan perangkat Desa ${this.$store.getters.getDesaUser.nama_desa}. Anda hanya dapat menginputkan permohonan penduduk di desa tempat anda bekerja.`,
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      this.$store.dispatch('setPendudukBantu', data)

    },
    ubahPenduduk() {
      this.$store.dispatch('setPendudukBantu', null)
    },
    submitAddPenduduk(e) {
      e.preventDefault()

      if (this.formPenduduk.nama_lengkap.length > 100) {
        swal({
          title: "Gagal",
          text: "Nama lengkap terlalu panjang",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.nik.length !== 16) {
        swal({
          title: "Gagal",
          text: "NIK terdiri dari 16 angka",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.no_kk.length !== 16) {
        swal({
          title: "Gagal",
          text: "Nomor KK terdiri dari 16 angka",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_kelamin === '') {
        swal({
          title: "Gagal",
          text: "Jenis kelamin tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.status_kawin === '') {
        swal({
          title: "Gagal",
          text: "Status Perkawinan tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_shdk === '') {
        swal({
          title: "Gagal",
          text: "Status hubungan dalam keluarga tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_agama === '') {
        swal({
          title: "Gagal",
          text: "Agama tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_desa === '') {
        swal({
          title: "Gagal",
          text: "Desa tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }


      let button = document.querySelector('#btnAddPenduduk')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Submit'

      let formData = new FormData()
      for (let key in this.formPenduduk) {
        if(key !== 'id_desa'){
          formData.append(key, this.formPenduduk[key])
        }
      }
      formData.append('id_desa', this.formPenduduk.id_desa.id_desa)
      this.$store.dispatch('storePenduduk', formData).then((res) => {
        if (res.data.status) {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml

          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          }).then(val => {
            // reset form
            Object.keys(this.formPenduduk).forEach((e) => {
              this.formPenduduk[e] = ''
            })
            this.formPenduduk.is_non_permanen = '0'
            this.$bvModal.hide('modal-tambah-penduduk')
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml

          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        // console.log(err)
        if (typeof (err.response.data.message) === 'object') {
          swal({
            title: "Gagal",
            text: "Pendaftaran gagal. Periksa form kembali.",
            icon: "error",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: err.response.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
    },
    loadKecamatan() {
      this.loadingKecamatan = true
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          let optKec = []
          res.data.data.forEach(e => {
            optKec.push(e)
          })
          this.optionKecamatan = optKec
          this.loadingKecamatan = false
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
    loadDesa() {
      this.loadingDesa = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesa = optDes
          this.loadingDesa = false
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
  },
  created() {
    if (this.$store.getters.getIsResetPermohonan) {
      let resetDataPermohonan = {
        tahap: 1
      }
      this.$store.dispatch('setDataPermohonan', resetDataPermohonan)
    }
  },
  mounted() {
    if (this.$store.getters.getDataPermohonan) {
      if (this.$store.getters.getDataPermohonan.tahap === 6) {
        setTimeout(() => {
          this.$store.dispatch('showPageLoader')
        }, 2000)

        let resetDataPermohonan = {
          tahap: 1
        }
        this.$store.dispatch('setDataPermohonan', resetDataPermohonan)
      }
    }
    this.loadKecamatan()
  },
  watch: {
    id_kecamatan(newVal, oldVal) {
      this.loadDesa()
    },
    'formPenduduk.tanggal_lahir'(newVal) {
      var today = new Date();
      var birthDate = new Date(newVal);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      this.formPenduduk.umur = age
    },
    'formPenduduk.id_shdk'(newVal) {
      const shdk = [
        'Kepala Keluarga',
        'Suami',
        'Istri',
        'Anak',
        'Menantu',
        'Cucu',
        'Orangtua',
        'Mertua',
        'Famili Lain',
        'Pembantu'
      ]
      let selShdk = shdk[parseInt(newVal) - 1]
      this.formPenduduk.shdk = selShdk
    }
  }
}
</script>